import React from "react";
import Gallery from "react-photo-gallery";

class SingleSelectedImageCaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImageIndex: null,
    };
  }
  handleImageSelection = ({ index, image }) => {
    var images = this.props.image;

    var img = images[index];
    if (img.hasOwnProperty("isSelected")) {
      images.filter((item) => {
        if (item.response == img.response) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
    }
      });
    } else {
      // img.isSelected = true;
  }

    this.setState({
      images: images,
      selectedImageIndex: index,
    });
    this.props.handleChange(null, img, this.props.rateeKey, index, "type");
  };
  handleImageClick = (event, { index }) => {
    console.log("imagesIndex", index);
    this.handleImageSelection(event, { index });
  };

  render() {
    const { image } = this.props;
    const { selectedImageIndex } = this.state;

    return (
      <div>
        <Gallery
          photos={image}
          onClick={this.props.handleImageSelection}
          renderImage={({ index, left, top, key, photo }) => (
            <SelectedImage
              key={key}
              index={index}
              margin={"2px"}
              photo={photo}
              left={left}
              top={top}
              onClickImage={(event) =>
                this.handleImageSelection({ event, index })
              }
              isSelected={index === selectedImageIndex}
              images={image}
            />
          )}
        />
      </div>
    );
  }
}

class SelectedImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }
  componentDidMount() {
    const { images } = this.props;
    setTimeout(() => {
      this.setState({
        isChecked: this.props.images[this.props.index].isSelected,
      });
    }, 300);
  }
  componentDidUpdate(prevProps, prevState) {
    const { index, images } = this.props;
    const main = images[index];

    if (main.isSelected !== prevState.isChecked) {
      this.setState({ isChecked: main.isSelected });
    }
  }
  handleOnClick = (event, photo, index) => {
    this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }));
    this.props.onClickImage(event, { photo, index });
  };
  render() {
    const { index, photo, margin, direction, isSelected } = this.props;

    const { isChecked } = this.state;
    const cont = {
      backgroundColor: "#eee",
      cursor: "pointer",
      overflow: "hidden",
      position: "relative",
      width: "",
      height: "",
      display: "flex",
      justifyContent: "space-around",
    };

    if (direction === "column") {
      cont.position = "absolute";
      cont.width = "200px";
    }

    return (
      <div
        style={{ margin, ...cont }}
        className={!isChecked || !isSelected ? "not-selected" : ""}
      >
        {isSelected || isChecked ? <CheckMark /> : ""}
        <img
          alt={photo.src}
          style={{ ...imgStyle }}
          {...photo}
          onClick={(event) => this.handleOnClick(event, { index })}
        />
        <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
      </div>
    );
  }
}

const CheckMark = () => (
  <div
    style={{
      left: "4px",
      top: "4px",
      position: "absolute",
      zIndex: "1",
    }}
  >
    <svg
      style={{ fill: "white", position: "absolute" }}
      width="34px"
      height="34px"
    >
      <circle cx="12.5" cy="12.2" r="8.292" />
    </svg>
    <svg
      style={{ fill: "#06befa", position: "absolute" }}
      width="44px"
      height="44px"
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  </div>
);

const imgStyle = {
  display: "flex",
  width:"290px", 
  height: "200px",
  transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
};

export default SingleSelectedImageCaptcha;
